
export default function About() {
  return (
    <section id="about" className="relative py-16 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-white to-blue-50 transform -skew-y-3 origin-top-left"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-2xl sm:text-5xl font-serif text-emerald-900 leading-tight">
                We specialize in helping landscaping businesses grow through strategic Instagram marketing
              </h2>
              
              <p className="text-sm sm:text-lg text-gray-700 leading-relaxed">
                Our proven system combines professional content creation, targeted ad campaigns, and ongoing management to deliver consistent, high-quality leads for your landscaping business. <strong className="text-emerald-700">We currently generate leads for under $5 each on average</strong> — with a one-time setup fee and flexible management options, we make it easy to scale your customer acquisition.
              </p>
            </div>
            
            <a href="#contact" className="inline-block bg-emerald-700 text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-emerald-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Learn Our Process
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            
            <div className="grid grid-cols-3 gap-3 sm:gap-6 pt-6 sm:pt-8">
              <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg">
                <div className="text-2xl sm:text-5xl font-bold text-emerald-700 mb-1 sm:mb-2">&lt;$5</div>
                <div className="text-xs sm:text-sm text-gray-600">Average Cost Per Lead</div>
              </div>
              <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg">
                <div className="text-2xl sm:text-5xl font-bold text-emerald-700 mb-1 sm:mb-2">$500K+</div>
                <div className="text-xs sm:text-sm text-gray-600">Saved for Clients</div>
              </div>
              <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg">
                <div className="text-2xl sm:text-5xl font-bold text-emerald-700 mb-1 sm:mb-2">80%</div>
                <div className="text-xs sm:text-sm text-gray-600">Average Cost Reduction</div>
              </div>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/a07c6cadd78a791609e9020a1c0db109.jpg" 
                alt="Landscaping Success Story"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 sm:top-6 left-4 sm:left-6 bg-white px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg">
                <span className="text-sm sm:text-base text-emerald-700 font-bold whitespace-nowrap">✓ Guaranteed Results</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent p-6 sm:p-8">
                <p className="text-white text-sm sm:text-lg italic leading-relaxed">
                  "Green Leads Network transformed our business. We went from struggling to find clients to having a consistent pipeline of quality leads every week."
                </p>
                <p className="text-white/90 text-xs sm:text-sm mt-2 sm:mt-3 font-semibold">
                  - Michael Rodriguez, Premium Landscapes LLC
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
